// core
import React from 'react';
import { Link } from 'react-router-dom'

// settings + utils
import Settings from 'config.js';
import Auth from 'services/Auth.js';
import API from 'utils/API.js';
import CSV from 'utils/CSV.js';

// lib
import Page from 'pages/shared/Page';
import Spinner from 'components/shared/Spinner';

// shared
import PageHeader from 'components/shared/PageHeader';
import ButtonsToolbar from 'components/shared/ButtonsToolbar';
import FiltersToolbar from 'components/shared/filters/FiltersToolbar';
import SortingToolbar from 'components/shared/SortingToolbar';

import MainHeading from 'components/shared/MainHeading';
import PageDataWrapper from 'pages/shared/PageDataWrapper.js';

// page-specific/etc.

import ReactTags from 'react-tag-autocomplete';

class KitEditorPage extends React.Component {
  constructor(props) {
    super(props);

    const kitId = this.props.match.params.kitId;
    if (!kitId) {
      alert('no kit ID');

      return false;
    }

    this.state = {
      queue: {},

      kit: this.props.appData.cache && this.props.appData.cache.kitsById[kitId] ? this.props.appData.cache.kitsById[kitId] : null,

      error: ''
    };

    this.handleChangeCompany = this.handleChangeCompany.bind(this);
    this.handleChangeName = this.handleChangeName.bind(this);
    this.handleChangeGroup = this.handleChangeGroup.bind(this);
    this.handleChangeNumServed = this.handleChangeNumServed.bind(this);
    this.toggleSchoolclass = this.toggleSchoolclass.bind(this);
    this.handleLocationsChange = this.handleLocationsChange.bind(this);
    this.getLocationName = this.getLocationName.bind(this);

    this.handleSave = this.handleSave.bind(this);
  }

  handleChangeCompany(e) {
    const name = e.currentTarget.value;
    this.setState((prevState) => {
      prevState.kit.company_name = name;

      return prevState;
    });
  }
  handleChangeGroup(e) {
    const groupId = e.currentTarget.value;

    this.setState((prevState) => {
      prevState.kit.group_id = groupId;
      prevState.kit.group.id = groupId;

      return prevState;
    });
  }
  handleChangeName(e) {
    const name = e.currentTarget.value;
    this.setState((prevState) => {
      prevState.kit.name = name;

      return prevState;
    });
  }

  handleChangeNumServed(e) {
    const numServed = e.currentTarget.value;
    this.setState((prevState) => {
      prevState.kit.num_served = numServed;

      return prevState;
    });
  }

  toggleSchoolclass(id) {
    const schoolclassIndex = this.state.kit.targeted_classes.indexOf(id);

    this.setState((prevState) => {
      if (schoolclassIndex === -1) {
        prevState.kit.targeted_classes.push(id);
      } else {
        prevState.kit.targeted_classes.splice(schoolclassIndex, 1);
      }

      return prevState;
    });
  }

  handleLocationsChange(e) {
    let locations = e.currentTarget.value.toUpperCase();
    this.setState((prevState) => {
      prevState.kit.targeted_locations = locations.split("\n");

      return prevState;
    });
  }

  getLocationName(id) {
    const location = this.props.appData.cache.locationsById[id];

    return location ? location.name : '';
  }

  handleSave() {
    this.setState((prevState) => {
      prevState.queue['save'] = 'Salvo prodotto...';

      return prevState;
    });

    let groupId = this.state.kit.group.id;
    let kitId =  this.state.kit.id;

    // console.log('group ID: ' + groupId);
    // console.log('product ID: ' + kitId);

    if (!kitId || !groupId) {
      console.error('Product or group are missing');
    }

    const endpoint = Settings.V3_API_URL + '/kits/' + kitId;

    console.log('endpoint: ' + endpoint);

    // console.dir(this.state.kit);

    let payload = {...this.state.kit};
    API.call('PUT', endpoint, payload,  (response, error) => {
      if (error) {
        this.setState((prevState) => {
          prevState.error = error.message + ' while saving product';
          delete prevState.queue['save'];

          return prevState;
        });

        return false;
      }

      if (!response.ok) {
        alert('Error saving product: ' + response.error);

        console.error('Error saving product');
        console.dir(response);

        this.setState((prevState) => {
          delete prevState.queue['save'];

          return prevState;
        });

        return false;
      }

      this.setState((prevState) => {
        delete prevState.queue['save'];
        prevState.just_saved = true;

        return prevState;
      });

      window.setTimeout(() => {
        this.setState((prevState) => {
          prevState.just_saved = false;

          return prevState;
        });
      }, 1000)
    });
  }

  render() {
    if (this.state.kit !== null) {
      return (
        <div className="container">
          <div className="row">
            <div className="col-12">
              <h1>Aggiorna kit: {this.state.kit.name}</h1>

              <h2>Info base</h2>

              <div className="form-group">
                <label>Committente <small className="text-muted">(ex.: "BMW", "Fiat")</small></label>
                <input type="text" className="form-control" name="company_name" onChange={this.handleChangeCompany} value={this.state.kit.company_name}/>
              </div>

              <div className="form-group">
                <label>Gruppo</label>
                <select className="form-control" name="group_id" onChange={this.handleChangeGroup} value={this.state.kit.group.id}>
                  {
                    this.props.appData.cache.kitGroups.map((group) => {
                      return <option value={group.id}>{group.name}</option>
                    })
                  }
                </select>
              </div>

              <div className="form-group">
                <label for="name">Nome</label>
                <input className="form-control" name="name" value={this.state.kit.name} onChange={this.handleChangeName} />
              </div>

              <h2>Target</h2>

              <p><strong>Numero libri/kit:</strong></p>

              <div className="form-group">
                <input className="form-control" name="name" value={this.state.kit.num_served} onChange={this.handleChangeNumServed} />
              </div>

              <p><strong>Classi:</strong></p>
              {
                this.props.appData.cache.schoolclassesGroups.length ? (
                  this.props.appData.cache.schoolclassesGroups.map((group) => {
                    return (
                      <div className="mb-3">
                        <h5 className="mt-4">{group.name}</h5>
                        {
                          group.schoolclasses.map((schoolclass) => {
                            let selected = this.state.kit.targeted_classes.indexOf(schoolclass.id) !== -1;
                            let iconClass = (selected ? 'fa fa-check' : 'fa fa-times') + ' mr-2';
                            let buttonClass = (selected ? 'btn btn-success' : 'btn btn-danger') + ' mr-2';

                            return (
                              <button className={buttonClass} onClick={() => {this.toggleSchoolclass(schoolclass.id)}}>
                                <i className={iconClass} /> {schoolclass.name}
                              </button>
                            );
                          })
                        }
                      </div>
                    );
                  })
                ) : ''
              }

              <h3>Localit&agrave;</h3>
              <p>Inserire <div className="badge badge-secondary">NUTS1</div>, <div className="badge badge-secondary">NUTS2</div>, <div className="badge badge-secondary">NUTS3</div> per aree, regioni e province, oppure <div className="badge badge-secondary">NUTS3 + codice catastale</div> per comune (ex.: <code className="badge badge-secondary">ITI14D612</code> per Firenze).<br />
              Inserire una localit&agrave; per riga per inserire molteplici localit&agrave;.</p>

              <div className="row">
                <div className="col-6">
                  <h5>&nbsp;</h5>{/* Just for spacing */}
                  <textarea className="form-control" style={{minHeight: '300px', height: 'calc(100% - 4rem)', overflow: 'auto'}} value={this.state.kit.targeted_locations.join("\n")} onChange={this.handleLocationsChange}></textarea>
                </div>
                <div className="col-6">
                  <h5 className="mt-2">Hai inserito:</h5>
                  {
                    this.state.kit.targeted_locations ? this.state.kit.targeted_locations.map((id) => {
                      let locationName = this.getLocationName(id);
                      return (
                        <div>
                          {
                            locationName ? (
                              <span>{id} (<span>{locationName}</span>)</span>
                            ) : (
                              <span className="alert-danger">{id} (?)</span>
                            )
                          }
                        </div>
                      );
                    }) : ''
                  }
                </div>
              </div>
              <div className="row mt-3">
                  <div className="col-12">
                    <p>
                      {
                        !this.state.queue['save'] && !this.state.just_saved ? (
                          <div>
                            <button className="btn btn-success" onClick={this.handleSave}><i className="fa fa-save mr-2" /> Salva modifiche</button>
                         </div>
                        ) : ''
                      }
                      {
                        this.state.queue['save'] ? (
                          <Spinner message={this.state.queue['save']} />
                        ) : ''
                      }
                      {
                        this.state.just_saved ? (
                          <div><i className="fa fa-check text-success" /> Salvato.</div>
                        ) : ''
                      }
                      </p>
                  </div>
              </div>
            </div>
          </div>
        </div>
      );
    } else {
      let queue = Object.keys(this.state.queue).map((name) => {
        return <div><Spinner message={this.state.queue[name]} /></div>
      });

      return (
        <div className="container">
          <div className="row">
            <div className="col-12">
              Aspetto...
              {queue}
            </div>
          </div>
        </div>
      );
    }
  }
}

export default KitEditorPage;



// WEBPACK FOOTER //
// ./src/pages/kits/KitEditorPage.js